import React from 'react'
import { BlockMain } from '@blocks/BlockMain'
import { scrollToEstateAgentsForm } from '@shared/components/forms/estate-agents'
import PageAnimation from '@shared/components/page-animation'

import { comfortBlocks, mainBlock, serviceProsList } from '../../data/estate-agents-page'

import { About } from './sections/about'
import { ComfortFormat } from './sections/comfort-format'
import { FormSection } from './sections/form-section'
import { Mortgage } from './sections/mortgage'
import { ServicePros } from './sections/service-pros'

import styles from './style.module.scss'

export const View = () => (
	<PageAnimation>
		<BlockMain
			adornmentClassname={styles.mainAdornment}
			className={styles.main}
			imageClassname={styles.image}
			data={{
				...mainBlock,
				title: (
					<div className={styles.title}>Ипотечный сервис для риелторов и кредитных брокеров</div>
				),
				descriptionClassName: styles.description,
			}}
			buttonProps={{ onClick: scrollToEstateAgentsForm, className: styles.btn }}
		/>
		<Mortgage />
		<ServicePros serviceProsList={serviceProsList} />
		<ComfortFormat blocks={comfortBlocks} />
		<About />
		<FormSection />
	</PageAnimation>
)
